import React, { useState } from "react";
import Step from "./Step";
import Result from "./Result";

const Wizard = props => {
  const [steps, setSteps] = useState({
    step: 0,
    optIndex: 0,
    options: [],
    price: 0
  });

  const [stepInfo] = useState([
    {
      title: "Kokio lygio programėlės jums reikia?",
      secTitle:
        "Galvojate apie minimalų perspektyvų produktą (MVP - ​ minimum viable product) ar pilnai išbaigtą produktą? ",
      options: [
        "Noriu kokybiškos, pilnai išbaigtos programėlės",
        "Noriu gero produkto, bet turiu ribotą biudžetą",
        "Svarbiausia yra įkandama kaina"
      ],
      optionsPrice: []
    },
    {
      title: "Kokios programėlės jums reikia?",
      secTitle:
        "Pasirinkitė operacinę sistema ant kurios veiks jūsų programėlė.",
      options: ["Android", "iOS (iPhone)", "Android ir iOS"],
      optionsPrice: [
        [6000, 4000, 2000],
        [6000, 4000, 2000],
        [11000, 7200, 3600]
      ]
    },
    {
      title: "Kokio dizaino jums reikia? ",
      secTitle: "Pasirinkite kokio lygio dizainas reikalingas jūsų programėlei",
      options: [
        "Paprastas, standartinių elementų dizainas",
        "Nestandartinis dizainas su nupieštais elementais ir animacijomis",
        "Pritaikyti mano internetinio puslapio dizainą"
      ],
      optionsPrice: [
        [4000, 2700, 1350],
        [12000, 8000, 4000],
        [8000, 5400, 2700]
      ]
    },
    {
      title: "Ar norite apmokęstinti savo programėlę?",
      secTitle: "Pasirinkite kokiu būdu norite monetizuoti programėlę",
      options: [
        "Programėlė bus nemokama",
        "Programėlė bus mokama",
        "Pirkimai programėlės viduje (In-app purchases)",
        "Kitas apmokesti/ Nežinau"
      ],
      optionsPrice: [
        [500, 330, 180],
        [500, 330, 180],
        [4000, 2680, 1320],
        [1000, 660, 360]
      ]
    },
    {
      title: "Ar vartotojai turės prisijungti prie programėlės?",
      secTitle: "Pasirinkite kokius prisijungimo būdus norite turėti",
      options: [
        "Facebook, google ir per el.paštą",
        "Tik per el. paštą ",
        "Prisijungimo nereikės",
        "Nesu tikras, nežinau "
      ],
      optionsPrice: [
        [4000, 2700, 1350],
        [2500, 1600, 840],
        [0, 0, 0],
        [2000, 1340, 640]
      ]
    },
    {
      title: "Ar bus reikalinga sinchronizacija su tinklapiu?",
      secTitle:
        "Nurodykite ar programėlei reikės dalintis duomenimis su tinklapiu/sistema",
      options: ["Taip ", "Ne", "Nesu tikras, nežinau"],
      optionsPrice: [[4000, 2700, 1350], [0, 0, 0], [2000, 1340, 640]]
    },
    {
      title: "Ar vartotojai turės savo profilius?",
      secTitle:
        "Nurodykite ar programėlės vartotojai galės kurtis personalizuotus profilius ",
      options: ["Taip ", "Ne", "Nesu tikras, nežinau"],
      optionsPrice: [[4000, 2700, 1350], [0, 0, 0], [2000, 1340, 640]]
    },
    {
      title: "Ar norėsite turėti turinio valdymo galimybę?",
      secTitle:
        "Administratoriaus aplinka kurioje jis galės tvirtinti, blokuoti vartotojus, siųsti Push notifications ir t.t. ",
      options: ["Taip ", "Ne ", "Nesu tikras, nežinau"],
      optionsPrice: [[4000, 2700, 1350], [0, 0, 0], [2000, 1340, 640]]
    },
    {
      title: "Kiek kalbų programėlė turi palaikyti? ",
      secTitle: "Pasirinkite kiek kalbų planuojate turėti programėlėje. ",
      options: ["Vieną ", "Kelias ", "Daug "],
      optionsPrice: [[0, 0, 0], [2000, 1340, 700], [4000, 2680, 1340]]
    }
  ]);

  function nextStep(newSteps) {
    if (steps.step < 9) {
      setTimeout(() => {
        setSteps({ ...newSteps, step: steps.step + 1 });
      }, 500);
    }
  }

  function prevStep() {
    if (steps.step > 1) {
      let previousStep = steps.step - 1;

      let newPrice = steps.price;
      newPrice -=
        stepInfo[previousStep].optionsPrice[steps.options[previousStep]][
          steps.optIndex
        ];

      let newOptions = steps.options;
      newOptions[previousStep] = null;

      const newSteps = {
        ...steps,
        options: newOptions,
        step: previousStep,
        price: newPrice
      };
      setSteps(newSteps);
    } else {
      resetSteps();
    }

    if (steps.step === 0) {
      props.handlePageChange(0);
    }
  }

  function resetSteps() {
    setSteps({
      step: 0,
      optIndex: 0,
      options: [],
      price: 0
    });
  }

  const stepBack = {
    display: "flex",
    flexDirection: "row",
    textTransform: "uppercase",
    alignItems: "center",
    color: "rgb(167,167,167)",
    width: "7rem",
    cursor: "pointer"
  };

  const priceStyle = {
    fontSize: "1rem",
    color: "rgb(167,167,167)",
    minWidth: "7rem",
    textAlign: "right"
  };

  if (steps.step < 9) {
    return (
      <div>
        <div className="header">
          <div
            onClick={prevStep}
            className="alternativeTitle arrowBack"
            style={stepBack}
          >
            <img
              className="silverArrow"
              alt="silverArrow"
              src="/skaiciuokle/img/silverArrow.png"
            />
            <div>Atgal</div>
          </div>

          <div style={priceStyle}>€ {steps.price}.00</div>
        </div>

        <div
          style={{
            ...props.contentStyle,
            paddingBottom: "0",
            display: "block"
          }}
        >
          <div className="stepCounter">{steps.step + 1}/9</div>
          <Step
            nextStep={nextStep}
            prevStep={prevStep}
            steps={steps}
            setSteps={setSteps}
            info={stepInfo[steps.step]}
          />
        </div>
      </div>
    );
  } else {
    return <Result resetSteps={resetSteps} price={steps.price} />;
  }
};

export default Wizard;
